import {
  ReportsActionTypes,
  FETCH_REPORTS_REQUEST,
  FETCH_REPORTS_SUCCESS,
  FETCH_REPORTS_FAILURE,
  CLEAR_REPORTS_DATA,
} from './actions';

export interface ReportsState {
  data: any;
  loading: boolean;
  error: string | null;
}

const initialState: ReportsState = {
  data: null,
  loading: false,
  error: null,
};

export const reportsReducer = (state = initialState, action: ReportsActionTypes): ReportsState => {
  switch (action.type) {
    case FETCH_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_REPORTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_REPORTS_DATA:
      return initialState;

    default:
      return state;
  }
};
